import { Tooltip } from '@mui/material';
import {
  Email,
  Phone,
  Home,
  Person,
  Apartment,
  FiberPin,
  ImportExport,
  Notes,
  SupportAgent,
  Numbers,
  Store,
  DriveEta,
  Place,
  DirectionsBoat,
  Face,
} from '@mui/icons-material';
import * as React from 'react';

interface IconProps {
  tooltipText?: string;
}

export const EmailIcon = ({ tooltipText = 'Email' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Email />
  </Tooltip>
);

export const PhoneIcon = ({ tooltipText = 'Phone' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Phone />
  </Tooltip>
);

export const AddressIcon = ({ tooltipText = 'Address' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Home />
  </Tooltip>
);

export const UserIcon = ({ tooltipText = 'User' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Face />
  </Tooltip>
);

export const PersonIcon = ({ tooltipText = 'Person' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Person />
  </Tooltip>
);

export const CompanyIcon = ({ tooltipText = 'Company' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Apartment />
  </Tooltip>
);

export const PinIcon = ({ tooltipText = 'PIN' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <FiberPin />
  </Tooltip>
);

export const EoriIcon = ({ tooltipText = 'EORI' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <ImportExport />
  </Tooltip>
);

export const NotesIcon = ({ tooltipText = 'Notes' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Notes />
  </Tooltip>
);

export const NotifyCompanyIcon = ({ tooltipText = 'Notify' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <SupportAgent />
  </Tooltip>
);

export const NumbersIcon = ({ tooltipText = 'Number' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Numbers />
  </Tooltip>
);

export const StoreIcon = ({ tooltipText = 'Store' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Store />
  </Tooltip>
);

export const VehicleIcon = ({ tooltipText = 'Vehicle' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <DriveEta />
  </Tooltip>
);

export const LocationIcon = ({ tooltipText = 'Location' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <Place />
  </Tooltip>
);

export const CarrierIcon = ({ tooltipText = 'Carrier' }: IconProps) => (
  <Tooltip title={tooltipText}>
    <DirectionsBoat />
  </Tooltip>
);
